import { wrapRootElementComponent } from './src/gatsby/wrapRootElement'

export const wrapRootElement = wrapRootElementComponent
